module.exports = __webpack_public_path__ + "a81688d113e55e954c376a940f6cdb14.jpg";